import * as React from 'react';
import { useSelector } from 'react-redux';

import { path, pathOr } from 'ramda';

import { QuizCompleted } from '../../components/QuizCompleted';
import { BackToPageContainer } from '../BackToPageContainer';
import { IBaseQuestionProps } from '../FormContainer/types/internal';
import { extraBtnsMap } from './constants/extraBtnsMap';
import { IExtraBtnProps } from './types';
import { useFormTracking } from '../../utils/useFormTracking';
import { selectIsWebview } from '../../selectors/selectIsWebview';
import { CloseWebview } from '../../components/QuizCompleted/components/CloseWebview';

import { DEFAULT_HELPER_TEXT, DEFAULT_TITLE } from './constants/defaults';

export const QuizCompletedContainer: React.FC<IBaseQuestionProps> = props => {
  const { title, helpText } = props.question;
  const isWebview = useSelector(selectIsWebview);
  const completeButtonName = pathOr('', ['extra', 'completeButton'], props.question);
  const CompleteButton = path<React.ComponentType<IExtraBtnProps>>([completeButtonName], extraBtnsMap);
  const { trackCompleteButton } = useFormTracking();

  /**
   * Для webview всегда показываем кнопку "Хорошо", закрывающую webview
   * На это "зашиты" мобильные приложения
   */
  const footer = isWebview ? <CloseWebview /> : CompleteButton && <CompleteButton onClick={trackCompleteButton} />;

  return (
    <QuizCompleted
      backToPage={<BackToPageContainer />}
      title={title || DEFAULT_TITLE}
      subtitle={pathOr(DEFAULT_HELPER_TEXT, ['text'], helpText)}
      footer={footer}
    />
  );
};

QuizCompletedContainer.displayName = 'QuizCompletedContainer';
